/**
 * We can't guarantee the order of event filesystem objects when returned from api call
 * We want to apply the following rules when sorting
 * 1. Drectories should appear last
 * 2. Compare non-directory items by displayType in descending alphabetical order: shows > schedule > list > broadcast
 * 3. Items with the same reference type should be sorted in alpabetical order
 * @param {Array} items
 * @returns Sorted Array of objects
 */
export const applyDefaultSortObjectListItems = items => {
  return items.sort((a, b) => {
    // Compare isDirectory values, w/ directories last
    if (a.isDirectory !== b.isDirectory) {
      return a.isDirectory ? 1 : -1;
    }

    // Compare non-directory items by displayType in descending alphabetical order: shows > schedule > list > broadcast
    if (!a.isDirectory && !b.isDirectory) {
      const displayTypeComparison = b.reference.displayType.localeCompare(
        a.reference.displayType
      );

      if (displayTypeComparison !== 0) {
        return displayTypeComparison;
      }

      // If displayType is the same, sort by name in ascending order
      return a.name.localeCompare(b.name);
    }

    // For any other cases, consider them equal
    return 0;
  });
};
